import styles from 'components/HealthcareEntries/Disclaimer/disclaimer.module.scss';

import type { FC } from 'react';

const staticBodyContent = `
      The information provided in this resource does not constitute legal,
    medical or any other professional advice, nor does it establish a standard
    of care. This resource has been created as an aid to you in your practice.
    The ultimate decision on how to use the information provided rests solely
    with you, the PolicyOwner.`;

const Disclaimer: FC = () => (
  <div className={styles.disclaimerContainer}>
    <p className={styles.disclaimerTitle}>Disclaimer</p>
    <p className={styles.disclaimerText}>{staticBodyContent}</p>
  </div>
);

export default Disclaimer;
